class LocalStorage {
	setPathName(key, value) {
		try {
			localStorage.setItem(key, value);
		} catch (err) {
			console.log("LocalStorage - setPathname : ", err);
		}
	}

	getPathName(key) {
		try {
			return localStorage.getItem(key);
		} catch (err) {
			console.log(" LocalStorage - getPathName err: ", err);
			return null;
		}
	}

	clearPathName(key) {
		try {
			return localStorage.removeItem(key);
		} catch (err) {
			console.log(" LocalStorage - clearPathName err: ", err);
			return null;
		}
	}

	clearStorage(key) {
		try {
			return localStorage.clear();
		} catch (err) {
			console.log(" LocalStorage - clearStorage err: ", err);
			return null;
		}
	}
}

export default new LocalStorage();
